<template>
    <div>
        <buttonlist @help="help" @search="search" @reflash="reflash" @exps="exps" ref="SetBtn"></buttonlist>
        <el-table
                id="xpane-0"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
                ref="singleTable"
        >
            <el-table-column type="selection" v-if="false"></el-table-column>
            <el-table-column show-overflow-tooltip prop="eCode" :label="$t('getapi[1832]')" width="100"></el-table-column>
            <el-table-column show-overflow-tooltip prop="eName" :label="$t('getapi[3201]')" width="100"></el-table-column>
            <el-table-column show-overflow-tooltip prop="LoginName" :label="$t('getapi[3202]')" width="100"></el-table-column>
            <el-table-column show-overflow-tooltip prop="mima" :label="$t('getapi[3]')" width="100"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Login_Limit" :label="$t('getapi[3229]')" width="100"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Remarks" :label="$t('getapi[143]')" width="100"></el-table-column>
            <el-table-column show-overflow-tooltip prop="login_times" :label="$t('getapi[6830]')" width="100"></el-table-column>
            <el-table-column show-overflow-tooltip prop="freeze_flag" :label="$t('getapi[6831]')" width="100">
                <template slot-scope="scope">
                    {{scope.row.freeze_flag == 0?$t('getapi[2053]'):$t('getapi[2052]')}}
                </template>
            </el-table-column>
            <el-table-column :label="$t('getapi[6048]')" width="100" v-show="inner_flag == 1">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="edit(scope.row)" type="text" size="small" :disabled="!btn.edit">{{ $t('getapi[34]') }}
                    </el-button>

                    <el-button @click.native.prevent="unsetFreeze(scope.row)" type="text" size="small" :disabled="scope.row.freeze_flag == 0">{{ $t('getapi[6832]') }}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage4"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>

        <el-dialog :title="$t('getapi[34]')" v-dialogDrag :visible.sync="isVisibleEdit" width="40%">
            <el-divider></el-divider>
            <div :style="{border:'1px solid #DCDFE6'}">
                <table>
                    <tr>
                        <td>{{$t('getapi[1832]')}}</td>
                        <td><el-input v-model="dataDetail.eCode" :disabled="true"></el-input></td>
                        <td>{{$t('getapi[3201]')}}</td>
                        <td><el-input v-model="dataDetail.eName" :disabled="true"></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[3202]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.eName" :disabled="true"></el-input>
                        </td>
                        <td>{{$t('getapi[3]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.LoginPassword" show-password></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[3229]')}}</td>
                        <td><el-input v-model="dataDetail.Login_Limit"></el-input></td>
                    </tr>
                </table>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isVisibleEdit = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="save">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>

        <serce :isVisible="isVisible" queryData="QS_FrmUsersShow" ref="ser" @getser="serclick"></serce>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'userview',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                userData: [], // 用户信息
                user: '',
                inner_flag: 0,
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('userview'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                dataDetail: {},
                isVisibleEdit: false,
                btn: {
                    edit: false
                },
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.authority();
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.inner_flag = that.userData.inner_flag;
            that.getView();

        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1070]"),this.$t("getapi[12]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                if(that.$limits.authority('plv3', 7,1) > 0){
                    that.btn.edit = true;
                } else {
                    that.btn.edit = false
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('userview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'QS_FrmUsersShow');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Ids: '',
                    Param: datac
                };
                that.$http.urlpost('/Sys/Currency/UserDataList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.loading = false;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.authority();
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
                that.authority();
            },
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Ids: '',
                    Param: datac,
                    LangType:that.$processdata.getLang(),
                    fromname: that.$t('getapi[1070]')
                };
                that.$http.urlpost('/Sys/Currency/UserExportToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            edit(row) {
                let that = this;
                that.isVisibleEdit = true;
                that.dataDetail = row
                console.log(row)
            },
            unsetFreeze(row){
                let that = this
                let parm = {
                    Login_Code: row.LoginName
                }
                that.$http.urlpost('/User/SYS_Users/UnSetFreezeflag', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView();
                    }
                });
            },
            save() {
                let that = this
                let parm = {
                    _num: that.dataDetail.num,
                    _loginpassword: that.dataDetail.LoginPassword,
                    _login_limit: that.dataDetail.Login_Limit
                }
                that.$http.urlpost('/Sys/Currency/SaveUsers', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isVisibleEdit = false;
                        that.getView();
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .el-form--inline .el-form-item {
        display: flex;
    }

    .tb-edit .el-input {
        display: none;
    }

    .tb-edit .current-row .el-input {
        display: block;
    }

    .tb-edit .current-row .el-input + span {
        display: none;
    }

    .el-table .hidden-row {
        display: none;
    }
</style>
